import { Component, OnInit, Input } from '@angular/core';

import { NoteType } from 'src/app/enums/note.enum';
import { ToastService } from 'src/app/services/toast.service';


@Component({
  standalone: true,
  providers: [
    ToastService
  ],
  selector: 'jr-note',
  templateUrl: './note.component.html',
  styleUrls: [
  ]
})
export class NoteComponent implements OnInit {
  @Input() type?: NoteType;

  icon?: string;
  style?: string;

  constructor(
    private toastService: ToastService
  ) { }

  ngOnInit() {
    this.type = this.type || NoteType.Info;

    this.icon = this.toastService.getIcon(this.type);
    this.style = this.toastService.getStyle(this.type);
  }
}